import { createAction, props } from '@ngrx/store';

import {
  type ApplyWorkflowNodePayload,
  type WebSocketConfig,
} from '@blaze-runtime/engine-data-access';
import { type RuntimeEvent } from '@blaze-runtime/engine-domain';
import { type DatasetResponse, type WorkflowNodeId } from '@blaze-shared/api-contracts-domain';
import { type RuntimeContext } from '@blaze-shared/elements-domain';
import { type PageContext } from '@blaze-shared/projects-domain';
import { type WorkflowSchema } from '@blaze-shared/schema-domain';
import { type Workflow } from '@blaze-shared/workflow-domain';

const TAG = '[Workflow Debugger]';

export const stopWorkflowDebugger = createAction(`${TAG} Stop workflow debugger`);
export const runWorkflowDebugger = createAction(
  `${TAG} Run workflow debugger`,
  props<{
    event?: RuntimeEvent;
    input?: any;
    inputsData?: { [key: string]: any };
    pageContext?: PageContext;
    schema?: WorkflowSchema;
    socketConfig?: WebSocketConfig;
    workflow?: Workflow;
    workflowId: string;
    workflowExecutionId: string;
  }>(),
);
export const runWorkflowDebuggerSuccess = createAction(
  `${TAG} Run workflow debugger success`,
  props<{
    workflowExecutionId: string;
    nodeId?: WorkflowNodeId;
    prevNodeId?: WorkflowNodeId;
    nodePayload?: ApplyWorkflowNodePayload;
  }>(),
);
export const runWorkflowDebuggerError = createAction(
  `${TAG} Run workflow debugger error`,
  props<{ error?: string; workflowExecutionId?: string }>(),
);

export interface WorkflowDebuggerRunNextNodePayload {
  inputs?: Record<string, DatasetResponse>;
  nextNodePayload?: ApplyWorkflowNodePayload;
  runToNode?: string;
}

export const workflowDebuggerRunNextNode = createAction(
  `${TAG} Workflow debugger run next node`,
  props<WorkflowDebuggerRunNextNodePayload>(),
);
export const workflowDebuggerStepOver = createAction(`${TAG} Workflow debugger step over`);
export const workflowDebuggerStepInto = createAction(`${TAG} Workflow debugger step into`);
export const workflowDebuggerStepOutside = createAction(`${TAG} Workflow debugger step outside`);
export const workflowDebuggerRunToNode = createAction(
  `${TAG} Workflow debugger run to node`,
  props<{ nodeId: WorkflowNodeId }>(),
);
export const workflowDebuggerSetBreakpoint = createAction(
  `${TAG} Workflow debugger set breakpoint`,
  props<{
    breakOnNode?: WorkflowNodeId | string;
    stepOver?: WorkflowNodeId | null;
    stepInto?: WorkflowNodeId | null;
  }>(),
);
export const workflowDebuggerNodeSuccess = createAction(
  `${TAG} Workflow debugger node success`,
  props<{
    nodePayload: ApplyWorkflowNodePayload;
    nodeId?: WorkflowNodeId;
    extras?: any;
  }>(),
);

export interface WorkflowDebuggerUpdateQueuedNodeContextPayload {
  ctx: Partial<RuntimeContext>;
}

export const workflowDebuggerUpdateQueuedNodeContextPayload = createAction(
  `${TAG} Workflow update queued node payload`,
  props<WorkflowDebuggerUpdateQueuedNodeContextPayload>(),
);
